import _ from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import { getProfileByName } from "../../store/profiles/profiles.selectors";
import { NO_VALUE_PLACEHOLDER } from "../table/helpers";

export const FormattedProfileName = ({ profileName }) => {
  const profile = useSelector(getProfileByName(profileName), _.isEqual);

  if (_.isEmpty(profile)) return NO_VALUE_PLACEHOLDER;

  return profile.type !== "custom" ? (
    <FormattedMessage id={profile.type} />
  ) : (
    profile.name
  );
};
